"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitlistListValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
exports.waitlistListValidationSchema = (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    isPrivate: (0, yup_1.boolean)(),
    item: mui_inputs_asset_1.templateAssetValidationSchema,
    contractId: yup_rules_1.dbIdValidationSchema,
});
//# sourceMappingURL=validation.js.map